<div
  class="wrapper"
  (mouseenter)="isHover = true"
  (mouseleave)="isHover = false"
>
  @if (!editMode) {
    <span>{{ control?.value || "-" }}</span>
  } @else {
    <app-reactive-input
      #reactiveInput
      (keyup.enter)="onConfirmEdit()"
      [fdCompact]="true"
      [formControl]="control"
      [customErrorMessage]="customErrorMessage"
      [placeholder]="placeholder"
    ></app-reactive-input>
  }
  <!-- style.display is used instead of ngIf since ngIf causes errors with click outside event -->
  <div [style.display]="isHover ? 'block' : 'none'" class="edit-btn">
    <button
      fd-button
      class="reactive-edit-in-place-button"
      i18n-title="
        XTOL|Reactive edit in place - edit
        button@@shared.reactive-edit-in-place.editButtonTooltip"
      title="Edit"
      [style.display]="!editMode ? 'block' : 'none'"
      [fdCompact]="true"
      fdType="transparent"
      (click)="onEdit()"
    >
      <app-icon icon="pen" size="sm"></app-icon>
    </button>
  </div>
  <div [style.display]="editMode ? 'block' : 'none'">
    <button
      fd-button
      id="confirm-button"
      i18n-title="
        XTOL|Reactive edit in place - apply
        button@@shared.reactive-edit-in-place.applyButtonTooltip"
      title="Apply"
      [fdCompact]="true"
      fdType="transparent"
      (click)="onConfirmEdit()"
      [disabled]="!control?.valid"
    >
      <app-icon icon="check" size="lg"></app-icon>
    </button>
    <button
      fd-button
      [fdCompact]="true"
      i18n-title="
        XTOL|Reactive edit in place - cancel
        button@@shared.reactive-edit-in-place.cancelButtonTooltip"
      title="Cancel"
      fdType="transparent"
      (click)="onCancelEdit()"
    >
      <app-icon icon="xmark" size="lg"></app-icon>
    </button>
  </div>
</div>
